import {
  Audio,
  File,
  Pdf,
  Video,
} from "@circle-react/components/shared/TrixEditor/BlockSelector/SelectorIcons";

interface FileTypeIconProps {
  content_type: string;
}

export const FileTypeIcon = ({ content_type }: FileTypeIconProps) => {
  if (content_type == "application/pdf") {
    return <Pdf />;
  }
  if (content_type?.startsWith("audio")) {
    return <Audio />;
  }
  if (content_type?.startsWith("video")) {
    return <Video />;
  }
  return <File />;
};
